import {UserCreditCardResponse, UserPaypalResponse} from '~/shared/services/bffService/api/interfaces/responses';

export type UserPayment = {
  id: number;
  type: string;
};

export const isUserPayment = (payment: unknown): payment is UserPayment =>
  !!payment &&
  typeof payment === 'object' &&
  'id' in payment && typeof payment.id === 'number' &&
  'type' in payment && typeof payment.type === 'string';

export type UserCreditCard = UserPayment & {
  brand: UserCreditCardResponse['brand'];
  suffix: UserCreditCardResponse['suffix'];
  expiration: UserCreditCardResponse['expiration'];
  isExpired: UserCreditCardResponse['isExpired'];
};

export const isUserCreditCard = (payment: unknown): payment is UserCreditCard =>
  isUserPayment(payment) &&
  'suffix' in payment && typeof payment.suffix === 'string' &&
  'expiration' in payment && typeof payment.expiration === 'string' &&
  'isExpired' in payment && typeof payment.isExpired === 'boolean';

export type UserPaypal = UserPayment & {
  email: UserPaypalResponse['email'];
};

export const isUserPaypal = (payment: unknown): payment is UserPaypal =>
  isUserPayment(payment) &&
  'email' in payment && typeof payment.email === 'string';
